var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99935 2.16602C3.88226 2.16602 2.16602 3.88226 2.16602 5.99935V10.7373C2.16602 11.0134 2.38987 11.2373 2.66602 11.2373C2.94216 11.2373 3.16602 11.0134 3.16602 10.7373V5.99935C3.16602 4.43454 4.43454 3.16602 5.99935 3.16602H10.6746C10.9507 3.16602 11.1746 2.94216 11.1746 2.66602C11.1746 2.38987 10.9507 2.16602 10.6746 2.16602H5.99935Z",
    fill: "#0E46C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2677 4.52819C10.1071 4.28671 7.89164 4.28671 5.731 4.52819C5.11548 4.59698 4.62086 5.08138 4.54831 5.70167C4.29206 7.89265 4.29206 10.106 4.54831 12.297C4.62086 12.9173 5.11548 13.4017 5.731 13.4705C7.89164 13.712 10.1071 13.712 12.2677 13.4705C12.8832 13.4017 13.3779 12.9173 13.4504 12.297C13.7067 10.106 13.7067 7.89265 13.4504 5.70167C13.3779 5.08138 12.8832 4.59698 12.2677 4.52819ZM5.84207 5.522C7.92889 5.28877 10.0698 5.28877 12.1566 5.522C12.3149 5.53969 12.4393 5.66482 12.4572 5.81783C12.7044 7.93164 12.7044 10.0671 12.4572 12.1809C12.4393 12.3339 12.3149 12.459 12.1566 12.4767C10.0698 12.7099 7.92889 12.7099 5.84207 12.4767C5.68384 12.459 5.55944 12.3339 5.54154 12.1809C5.29431 10.0671 5.29431 7.93164 5.54154 5.81783C5.55944 5.66482 5.68384 5.53969 5.84207 5.522Z",
    fill: "#0E46C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.c0552c9aa939df22e3701f8267399db4.svg";
export { ForwardRef as ReactComponent };